import React from 'react';
import { Box, Slider, Typography } from '@mui/material';

import HomeBottomButtonOptionsSettings from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsSettings';
import { LANGUAGES } from '@constants/language';
import {
  NavigationModeType,
  NAVIGATION_MODES,
} from '@constants/navigationMode';

import { SettingsGeneralViewProps } from './interfaces';
import { useStyles } from './styles';
import { env } from 'env';
import { isDesktop } from 'react-device-detect';
import ReconnectExternalKeyboardButton from '@core/dashboard/components/Overlays/ExternalKeyboardOverlay/ReconnectExternalKeyboardButton';

const { REACT_APP_FEATURE_SHOW_LANGUAGE = 'true' } = env;

const showLanguage = REACT_APP_FEATURE_SHOW_LANGUAGE === 'true';

const SettingsGeneralView = ({
  selectLanguage,
  selectedLanguage,
  selectNavigationMode,
  selectedNavigationMode,
  translate,
  gameSound,
  handleChange,
  participantsSound,
  handleLoudness,
  languages,
}: SettingsGeneralViewProps) => {
  const classes = useStyles();

  const activeLanguages = LANGUAGES.filter(
    ({ key }) =>
      !languages?.length ||
      languages.some((lang) => lang.toLowerCase() === key.toLowerCase()),
  ).map(({ label, key }) => ({ label, deviceId: key }));

  const navigationModes = NAVIGATION_MODES.map(({ id, labelKey }) => ({
    label: translate(labelKey),
    deviceId: id,
  }));

  return (
    <>
      {showLanguage ? (
        <HomeBottomButtonOptionsSettings
          devices={activeLanguages}
          handleSelect={(e) => selectLanguage(e.target.value)}
          label={translate('settingsModal.language')}
          selectedValue={selectedLanguage}
          sx={classes.buttonOptions}
        />
      ) : null}
      <HomeBottomButtonOptionsSettings
        devices={navigationModes}
        handleSelect={(e) =>
          selectNavigationMode(e.target.value as NavigationModeType)
        }
        label={translate('settingsModal.navigationMode')}
        selectedValue={selectedNavigationMode}
        sx={classes.buttonOptions}
      />

      {/*<HomeBottomButtonOptionsSettings*/}
      {/*  devices={devices}*/}
      {/*  handleSelect={(e) => setStreamQuality(e.target.value)}*/}
      {/*  label={translate('settingsModal.quality')}*/}
      {/*  selectedValue={streamQuality}*/}
      {/*  SelectIcon={HighQualityIcon}*/}
      {/*/>*/}
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.worldSound')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={gameSound * 100}
          onChange={handleChange}
        />
      </Box>
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.loudness')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={participantsSound * 100}
          onChange={handleLoudness}
        />
      </Box>
      {!isDesktop && (
        <Box sx={classes.slider}>
          <ReconnectExternalKeyboardButton
            label={translate('settingsModal.reconnectExternalKeyboard')}
            fullWidth
            showReconnectedNotification
          />
        </Box>
      )}
    </>
  );
};

export default SettingsGeneralView;
